import { Link } from 'react-router-dom';

const CONTACT_EMAIL = 'info@coffee214.com';

const NAV_LINKS = [
  { to: '/catalog', label: 'Каталог' },
  { to: '/subscription', label: 'Підписка' },
  { to: '/contact', label: 'Зворотній зв’язок' },
] as const;

function FooterHeading({ children }: { children: string }) {
  return (
    <div className="mb-5">
      <div className="mb-4 h-[2px] w-16 bg-accent" />
      <p className="mono-label">{children}</p>
    </div>
  );
}

function MailIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="5" width="18" height="14" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  );
}

export function Footer() {
  return (
    <footer className="border-t border-line">
      <div className="section-pad grid gap-10 md:grid-cols-2">
        <div>
          <FooterHeading>НАВІГАЦІЯ</FooterHeading>
          <ul className="m-0 list-none space-y-3 p-0">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-[14px] text-ink no-underline hover:text-accent">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <FooterHeading>КОНТАКТИ</FooterHeading>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="group inline-flex items-center gap-3 text-[14px] text-ink no-underline hover:text-accent"
          >
            <span className="flex h-10 w-10 items-center justify-center border border-line text-accent group-hover:border-accent">
              <MailIcon />
            </span>
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-line px-[clamp(24px,5vw,72px)] py-5">
        <p className="mono-label m-0">
          © {new Date().getFullYear()} 214° Coffee · Всі права захищено
        </p>
        <Link to="/privacy" className="mono-label no-underline hover:text-accent">
          Політика конфіденційності
        </Link>
      </div>
    </footer>
  );
}
